import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import Navbar from "./components/Navbar";

import Home from "./pages/Home";
//import Services from "./pages/Services";
import PracticeAreas from "./pages/PracticeAreas";
import Contact from "./pages/Contact";
import About from "./pages/About";
import Footer from "./components/Footer";
import DisclaimerModal from "./components/DisclaimerModal";
import CivilLaw from "./pages/CivilLaw";
//import About1 from "./pages/About1";
import CorporateLaw from "./pages/CorporateLaw";
import FamilyLaw from "./pages/FamilyLaw";
import MiningLaw from "./pages/MiningLaw";
import RegulatoryCompliance from "./pages/RegulatoryCompliance";
import CriminalLaw from "./pages/CriminalLaw";
import Labor from "./pages/Labor";
import "./App.css";
import { trackPageView } from "./utils/analytics";

function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location]);

  return null;
}

const App = () => {
  const [showDisclaimer, setShowDisclaimer] = useState(true);
  useEffect(() => {
    const handleContextMenu = (e) => e.preventDefault();
    const disableCopy = (e) => e.preventDefault();
    document.addEventListener("copy", disableCopy);
    document.addEventListener("contextmenu", handleContextMenu);
    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
      document.removeEventListener("copy", disableCopy);
    };
  }, []);
  /*   useEffect(() => {
    const disableCopy = (e) => e.preventDefault();
    document.addEventListener("copy", disableCopy);
    return () => {
      document.removeEventListener("copy", disableCopy);
    };
  }, []); */
  const handleDisclaimerClose = () => {
    setShowDisclaimer(false);
  };

  return (
    <Router>
      <AnalyticsTracker />
      <Navbar />
      {showDisclaimer && (
        <DisclaimerModal
          show={showDisclaimer}
          onClose={handleDisclaimerClose}
        />
      )}
      <Routes>
        <Route path="/" element={<Home />} />
        {/*  <Route path="/services" element={<Services />} /> */}
        <Route path="/practice-areas" element={<PracticeAreas />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/about" element={<About />} />
        <Route path="/civil" element={<CivilLaw />} />
        <Route path="/family" element={<FamilyLaw />} />
        <Route path="/corporate" element={<CorporateLaw />} />
        <Route path="/mining" element={<MiningLaw />} />
        <Route path="/regulatory" element={<RegulatoryCompliance />} />
        <Route path="/criminal" element={<CriminalLaw />} />
        <Route path="/labor" element={<Labor />} />

        {/*   <Route path="/about1" element={<About1 />} /> */}
      </Routes>
      <Footer />
    </Router>
  );
};

export default App;
